var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12381_7499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath2924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2922",
    d: "M0 0.211454H17.16V21H0V0.211454Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12381_7499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2928",
    d: "M16.6573 17.9141C16.6573 11.8595 12.6058 6.95135 7.60806 6.95135H6.60259V3.29712L0.502747 9.38751L6.60259 14.2598V10.6056H7.60806C11.7418 10.6056 14.8086 13.4349 16.6573 17.9141Z",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo1);
export default __webpack_public_path__ + "static/media/Undo_1.2a988929b591202a38288be07206b75e.svg";
export { ForwardRef as ReactComponent };